import Cookies from 'js-cookie'

Promise.all([import('./top-parks-rebranded-pop-up.scss')]).then(() => {
  const widget = $('.widget.top-parks-rebranded-pop-up')

  // If widget not found, mark popup as disabled
  if (widget.length === 0) {
    Cookies.set('DisableTopParksRebrandedPopUp', true, { path: '/' })
    return
  }

  widget.each(function (i, el) {
    $(el).data('widget', new TopParksRebrandedPopUp(el, i))
    $(document).ready(function () {
      $(el).data('widget').init()
    })
  })
})

function TopParksRebrandedPopUp(el, index) {
  const self = this
  self.el = $(el)
  self.uid = `TopParksRebrandedPopUp_${index}`
  self.modal = self.el.find('.ui.modal')

  self.getAppearanceLimit = () => parseInt(self.modal.find('.appearance-limit').val())

  self.hasReachedAppearanceLimit = function () {
    const appearanceCount = parseInt(Cookies.get('TopParksRebrandedPopUpAppearanceCount'))
    return appearanceCount >= self.getAppearanceLimit()
  }

  self.close = function () {
    const hasUserOptOut = self.modal.find('.opt-out').is(':checked')
    let appearanceCount = parseInt(Cookies.get('TopParksRebrandedPopUpAppearanceCount'))

    if (hasUserOptOut === true) {
      appearanceCount = self.getAppearanceLimit()
    } else {
      appearanceCount > 0 ? appearanceCount++ : (appearanceCount = 1)
    }

    Cookies.set('DisableTopParksRebrandedPopUp', hasUserOptOut, {
      path: '/',
    })

    // Store the number of times this modal has appeared
    Cookies.set('TopParksRebrandedPopUpAppearanceCount', appearanceCount, {
      expires: 365, // in days
      path: '/',
    })

    self.modal.modal('hide')
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('TopParksRebrandedPopUp init', self)
    }

    // Check if we should show the modal on page load
    if (self.hasReachedAppearanceLimit() || Cookies.get('DisableTopParksRebrandedPopUp') === 'true') return

    window.dbs.globalEvents.subscribe('shepherdNext', function (item) {
      if (item !== self.uid) return
      console.log('[SHEPHERD][popup]', item === self.uid, item)

      self.modal
        .modal({
          closable: false,
          onHidden: () => window.dbs.globalEvents.emit('shepherdDone', self.uid),
        })
        .modal('show')
    })

    self.modal.find('.close-button').click(function (event) {
      event.preventDefault()
      self.close()
    })

    window.dbs.globalEvents.emit('shepherdQueue', self.uid)
  }
}
